import { render, staticRenderFns } from "./SkupStavkaImportExcel.vue?vue&type=template&id=3236d06f&scoped=true&"
import script from "./SkupStavkaImportExcel.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaImportExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236d06f",
  null
  
)

export default component.exports